import { render, staticRenderFns } from "./AlbumSongsModal.vue?vue&type=template&id=06c06529&scoped=true&"
import script from "./AlbumSongsModal.vue?vue&type=script&lang=js&"
export * from "./AlbumSongsModal.vue?vue&type=script&lang=js&"
import style0 from "./AlbumSongsModal.vue?vue&type=style&index=0&id=06c06529&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c06529",
  null
  
)

export default component.exports